import React from 'react';

const Location = () => {
    return (
        <div id='location' className="info-section">
            <h2 className="info-title">Location</h2>
            <div className="info-details">
                <div className="info-item">
                    <p className="venue-name">Pfizer Auditorium</p>
                    <a
                        href="https://www.google.com/maps/search/?api=1&query=Pfizer%20Auditorium%2C%205%20MetroTech%20Center%2C%20Brooklyn%2C%20NY%2011201"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="map-link"
                    >
                        5 MetroTech, Brooklyn, NY
                    </a>
                </div>
            </div>
            <div className="map-container">
                <iframe
                    loading="lazy"
                    src="https://www.google.com/maps?q=Pfizer%20Auditorium%2C%205%20MetroTech%20Center%2C%20Brooklyn%2C%20NY%2011201&output=embed&z=18"
                    title="Pfizer Auditorium at 5 MetroTech"
                    aria-label="Pfizer Auditorium at 5 MetroTech"
                    width="600"
                    height="450"
                ></iframe>
            </div>

        </div>
    );
};

export default Location;
